/* eslint-disable */
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
export default function Detail(props){
  let navigate = useNavigate()
  let location = useLocation()
  let [name, setName] = useState('')
  let [info, setInfo] = useState({})
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    if(location.pathname.includes('notice')){
      setInfo(props.noticeList.filter(a => a.key == location.pathname.split('/')[2].match(/\d+/)[0])[0])
      setName('공지사항')
    }
    if(location.pathname.includes('employ')){
      setInfo(props.employList.filter(a => a.key == location.pathname.split('/')[2].match(/\d+/)[0])[0])
      setName('채용공고')
    }
  }, [])
  return(
    <>
      <div className="detailBanner" style={{backgroundImage:'url(/img/sub_banner_01.png)'}}>
        <div className="detailName">{name}</div>
      </div>
      <div className="contents">
        <div className="detailTop">
          <div className="detailTopBox">
            <div className="detailTopCLSFC">{info.classification}</div>
            <div className="detailTopDate">{info.date}</div>
          </div>
          <button
            className="detailBackBtn"
            onClick={() => {
              if(location.pathname.includes('notice')){
                navigate('/company/notice')
              }
              if(location.pathname.includes('employ')){
                navigate('/human/employ')
              }
            }}
          >
            뒤로
          </button>
        </div>
        <div className="detailTitle">{info.title}</div>
        {
          info.src && <img src={info.src} className="detailImg" alt=""/>
        }
        <div className="detailContent" dangerouslySetInnerHTML={{__html : info.content}}></div>
        <button
          className="detailBackBtn center"
          onClick={() => {
            if(location.pathname.includes('notice')){
              navigate('/company/notice')
            }
            if(location.pathname.includes('employ')){
              navigate('/human/employ')
            }
          }}
        >
          뒤로
        </button>
      </div>
    </>
  )
}